import React, { useState, startTransition } from "react";
import Form from "react-bootstrap/Form";
import produce from "immer";

import { connect } from "react-redux";

function ListFilter(props) {
  const [showMore, setShowMore] = useState(false);

  const updateListFilter = (index, value, oldOptionList) => {
    let nextOptionList = produce(oldOptionList, (draftState) => {
      draftState[index].isChecked = value;
    });
    let filterString = nextOptionList
      .filter((x) => x.isChecked === true)
      .map((x) => x.option);
    props.updateFilters(
      filterString,
      props.filterType.data,
      oldOptionList[index].url
    );
  };

  let optionList = props.filterType.options.map((item) => ({
    ...item,
    isChecked: props.matchingFilterString.includes(item.option),
  }));

  return (
    <div className="filter_list_item">
      {optionList.map((item, index) => {
        let paddingBottom = showMore
          ? index === optionList.length - 1
            ? 0
            : 6
          : index === Math.min(optionList.length - 1, 6)
          ? 0
          : 6;
        if (index < 7 || showMore) {
          return (
            <Form.Label
              key={index}
              style={{
                paddingBottom: paddingBottom,
                fontSize: 16,
                display: "flex",
                cursor: "pointer",
              }}
            >
              <Form.Check
                onChange={(event) => {
                  startTransition(() => {
                    updateListFilter(index, !item.isChecked, optionList);
                  });
                }}
                checked={item.isChecked}
              />
              <span>
                {item.option}
                <span style={{ color: "grey" }}> ({item.count})</span>
              </span>
            </Form.Label>
          );
        } else {
          return null;
        }
      })}
      {!showMore && optionList.length > 5 && (
        <div style={{ marginBottom: 10 }}>
          <span
            style={{
              color: "var(--primary-color-600)",
              fontWeight: 700,
              fontSize: 14,
            }}
            onClick={() => {
              setShowMore(true);
            }}
          >
            Show More
            <i
              aria-hidden
              style={{
                color: "var(--primary-color-600)",
                marginLeft: 5,
                fontSize: 18,
              }}
              className="fas fa-caret-down"
            />
          </span>
        </div>
      )}
    </div>
  );
}

export default connect()(ListFilter);
